/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */

  /* ================================= */
/* 🔥 CATEGORY NAVIGATION LOGIC */
/* ================================= */
 
function initAllCategoryNav() {
  document.querySelectorAll('[id^="cat-list-"]').forEach(function(el){
    const sectionId = el.id.replace('cat-list-', '');
    initCategoryNav(sectionId);
  });
}
 
function initCategoryNav(sectionId) {
  var catList = document.getElementById('cat-list-' + sectionId);
  var moreItem = document.getElementById('more-item-' + sectionId);
  var moreBtn = document.getElementById('more-btn-' + sectionId);
  var moreDropdown = document.getElementById('more-dropdown-' + sectionId);
 
  if (!catList || !moreItem) return;
 
 var allItems = Array.from(catList.querySelectorAll('.parent-item'))
  .filter(item => !item.classList.contains('more-item'));
 
function buildMoreDropdownItem(sourceItem) {
  var pill = sourceItem.querySelector('.category-pill');
  var subList = sourceItem.querySelector('.subcategory-list');

  var li = document.createElement('li');

  if (subList && subList.children.length > 0) {
    var label = document.createElement('span');
    label.className = 'more-sub-label';
    label.textContent = pill.textContent.replace('▼', '').trim();
    li.appendChild(label);

    var ul = document.createElement('ul');
    ul.className = 'more-sub-list';

    Array.from(subList.querySelectorAll('a')).forEach(function (a) {
      var subLi = document.createElement('li');
      var subA = document.createElement('a');
      subA.href = a.href;
      subA.textContent = a.textContent;
      subLi.appendChild(subA);
      ul.appendChild(subLi);
    });

    li.appendChild(ul);

  } else {
    var a = document.createElement('a');
    a.href = pill.href;
    a.textContent = pill.textContent.replace('▼', '').trim();
    li.appendChild(a);
  }

  return li;
}
 
function recalculate() {
  // wait until visible
  if (!catList.offsetWidth) return;
  // PREVENT FLICKER
  catList.style.visibility = 'hidden';
  // RESET
  allItems.forEach(item => item.style.display = '');
  moreDropdown.innerHTML = '';
  // TEMP SHOW MORE
  moreItem.classList.remove('hidden');
  // FORCE REFLOW (important)
  moreItem.offsetHeight;
  const containerWidth = catList.getBoundingClientRect().width;
  const moreWidth = moreItem.getBoundingClientRect().width || 80;
  let usedWidth = 0;
  let overflowStarted = false;
  allItems.forEach(item => {
    const itemWidth = item.getBoundingClientRect().width + 12;
    if (overflowStarted || (usedWidth + itemWidth + moreWidth > containerWidth)) {
      overflowStarted = true;
      moreDropdown.appendChild(buildMoreDropdownItem(item));
      item.style.display = 'none';
    } else {
      usedWidth += itemWidth;
    }
  });
  // HIDE MORE IF EMPTY
  if (moreDropdown.children.length === 0) {
    moreItem.classList.add('hidden');
  }
  catList.style.visibility = 'visible';
}
 
  // EVENTS
  moreBtn.addEventListener('click', function (e) {
    e.stopPropagation();
    const isOpen = moreDropdown.classList.toggle('open');
    moreBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  });
 
  document.addEventListener('click', function () {
    moreDropdown.classList.remove('open');
    moreBtn.setAttribute('aria-expanded', 'false');
  });
 
  // OBSERVER
  if (window.ResizeObserver) {
    new ResizeObserver(recalculate).observe(catList);
  } else {
    window.addEventListener('resize', recalculate);
  }
 
  // INITIAL RUN
  setTimeout(recalculate, 100);
}

window.initAllCategoryNav = initAllCategoryNav;
window.PXUTheme.jsHeader = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);

      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    if (!window.categoryNavInitialized) {
  window.categoryNavInitialized = true;

  setTimeout(initAllCategoryNav, 300);

  window.addEventListener("load", function () {
    setTimeout(initAllCategoryNav, 500);
  });
}
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset) {
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', false);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', overlayBoolean);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
  const searchBox = document.querySelector(".custom-search-box");

  if (!searchBox) return;

  searchBox.classList.toggle("active");

  const input = searchBox.querySelector("input");
  if (input) input.focus();
},
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;

    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}
document.addEventListener("DOMContentLoaded", function () {

  const inputs = document.querySelectorAll("[data-predictive-search-input]");

  inputs.forEach(input => {
    const resultsBox = input.closest("form").querySelector("[data-predictive-search]");

    input.addEventListener("input", function () {
      const query = input.value.trim();

      fetch(`/search/suggest.json?q=${query}&resources[type]=product`)
        .then(res => res.json())
        .then(data => {

          const products = data.resources.results.products || [];

          // ❌ No results
          if (!products.length) {
            resultsBox.innerHTML = "<p>No results</p>";
            resultsBox.style.display = "block";
            return;
          }

          let html = "<ul>";
          products.forEach(product => {
            if (!product.price) return;
            const price = parseFloat(product.price).toFixed(2);
            let compareHTML = "";

            if (product.compare_at_price_max && product.compare_at_price_max > product.price) {
              compareHTML = `<span class="compare-price">$${parseFloat(product.compare_at_price_max).toFixed(2)}</span>`;
            }

            let priceHTML = `
              <span class="price">$${price}</span>
              ${compareHTML}
            `;


            html += `
              <li class="predictive-item">
                <a href="${product.url}" class="predictive-link">

                  <div class="predictive-left">
                    <img src="${product.featured_image.url}" alt="${product.title}">
                  </div>

                  <div class="predictive-right">
                    <p class="predictive-title">${product.title}</p>
                    <div class="predictive-price">
                      ${priceHTML}
                    </div>
                  </div>

                </a>
              </li>
            `;
          });

          html += "</ul>";

          resultsBox.innerHTML = html;
          resultsBox.style.display = "block";
        });
    });

    // hide when clicking outside
    document.addEventListener("click", function (e) {
      if (!input.contains(e.target) && !resultsBox.contains(e.target)) {
        resultsBox.style.display = "none";
      }
    });

  });
document.addEventListener("click", function(e) {
  const btn = e.target.closest(".ajax-add-to-cart");
  if (!btn) return;

  e.preventDefault();
  e.stopPropagation();

  const variantId = btn.dataset.variantId;

  if (!variantId) {
    console.error("Variant ID missing");
    return;
  }

  btn.innerText = "Adding...";
  btn.disabled = true;

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json"
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(res => {
    if (!res.ok) throw new Error("Add to cart failed");
    return res.json();
  })
  .then(data => {

  if (window.PXUTheme && window.PXUTheme.jsAjaxCart) {
    window.PXUTheme.jsAjaxCart.updateView();
  }
    btn.innerText = "Added";
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        document.querySelectorAll('[data-bind="itemCount"]').forEach(el => {
          el.innerText = cart.item_count;
        });
      });

    setTimeout(() => {
      btn.innerText = "Add to Cart";
      btn.disabled = false;
    }, 1500);
  })
  .catch(err => {
    console.error(err);
    btn.innerText = "Error";
    btn.disabled = false;
  });
});

});
/******/ })()
;